export default __webpack_public_path__ + "static/media/white.c3d4b4df.svg";